import Cards from "../../../Cards/Cards";
import RedTitle from "../RedTitle/RedTitle";
import classes from "./WorkList.module.scss";
import Tooltip from '../../../Tooltip/tooltip';
const data = [
  {
    number: "a.",
    title: "переоформили большинство шаблонов сайта",
  },
  {
    number: "b.",
    title: "изменили функциональные элементы карточки товаров и элементов списка товаров",
  },
  {
    number: "с.",
    title: "Доработали выпадающее меню",
  },
  {
    number: "d.",
    title: "полностью переработали корзину товаров и все этапы оформления заказа",
  },
  {
    number: "e.",
    title: "ввели в Личном кабинете возможность создавать и сохранять адреса доставки",
  },
  {
    number: "f.",
    title: "создали в личном кабинете  анкеты для пользователей",
  },
  {
    number: "g.",
    title: "разработали функционально сть купонов и подарочных сертификатов",
  },
  {
    number: "h.",
    title: "внедрили ловца лидов",
  },
  {
    number: "i.",
    title: "исправили работу скидочной системы",
  },
  {
    number: "j.",
    title: <>ввели персональные рекомендации товаров на основе <span className={classes.TooltipWrapper}>Big-data<Tooltip customClass={classes.Tooltip} text={"Технология Bitrix, которая позволяет анализировать историю поведения пользователя и на основе этого подбирать им наиболее интересные для них товары"} /></span></>,
  },
  {
    number: "k.",
    title: "исправили огромное количество ошибок в работе сайта",
  },
]

const WorkList = () => {
  return (
    <div className={classes.WorkList}>
      <div className={classes.Wrapper}>
        <RedTitle
          customClass={classes.Title}
          title={"Техническая поддержка"}
          number={"01."}
          text={"После обсуждения с заказчиком наших выводов и учитывая всю накопившуюся до нас проблематику мы:"}
        />
        {data.map((elem, i) => {
          return (
            <Cards
              customClass={classes.Item}
              customTitleClass={classes.CardsTitle}
              number={elem.number}
              title={elem.title}
              text={elem.text}
              key={i}
              />
          )
        })}
      </div>
      <div className={classes.Footer}>
        <p className={classes.Light}>
        Кроме этих работ, в отдел поддержки постоянно поступали задачи, основанные на выводах SEO-специалистов.
        </p>
        <p className={classes.Bold}>
        На основе этих вводных на сайте был реализован ЧПУ-фильтр каталога, который, в момент запуска расширил количество полезных и индексируемых страниц сайта до 50 000.
        </p>
      </div>
    </div>
  )

}

export default WorkList;